import { parseFragment, serialize } from 'parse5';

// Round-trip CMS-supplied HTML through parse5 (the same HTML5 spec parser used
// by jsdom and aligned with what the browser does) so that unbalanced or
// otherwise sloppy markup is normalized BEFORE it reaches the SSR output.
//
// CMS authors regularly save markup with mismatched tags (e.g. `<div><div>...
// </div>` with one missing close tag) — we found 45 / 71 showroom HIHT fields
// in this state during CON-8169. When `dangerouslySetInnerHTML` emits the raw
// string, the browser silently auto-closes the missing tags during HTML
// parsing, which shifts subsequent DOM positions out from under React and
// produces cascading hydration mismatches throughout the page.
//
// Running the same content through parse5 server-side produces the same
// auto-corrected tree, so the SSR string already matches what the browser
// will build — no DOM shift, no hydration warnings. Empty / non-string input
// is returned unchanged.
const balanceCmsHtml = html => {
  if (typeof html !== 'string' || html === '') return html;
  try {
    return serialize(parseFragment(html));
  } catch {
    // parse5 is very tolerant; reaching this path would be unexpected. Fall
    // back to the original string rather than dropping content.
    return html;
  }
};

export default balanceCmsHtml;
